module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portal-calendar",
    attrs: {
      "id": "calendar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb50b1dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/portal/PortalCalendar.vue
// module id = 1528
// module chunks = 6